import { Skeleton } from "@/components/ui/skeleton";

interface ChaptersListSkeletonProps {
  type?: "page" | "timestamp";
}

export function ChaptersListSkeleton({ type = "page" }: ChaptersListSkeletonProps) {
  return (
    <div className="space-y-3">
      {[1, 2, 3, 4].map((i) => (
        <div
          key={i}
          className="rounded-lg border border-border bg-card p-4"
        >
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1 space-y-2">
              <Skeleton className="h-5 w-3/4" /> {/* Title */}
              <Skeleton className="h-4 w-full" /> {/* Summary line 1 */}
              <Skeleton className="h-4 w-2/3" /> {/* Summary line 2 */}
            </div>
            {/* Reference badge */}
            <Skeleton 
              className={type === "page" ? "h-6 w-16 shrink-0" : "h-6 w-14 shrink-0"} 
            />
          </div>
        </div>
      ))}
    </div>
  );
}
